import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
  root: {
    height: '100%'
  }
})

export default useStyles
